import * as React from "react";
export class RibbonButton extends React.Component {
    render() {
        const cls = "rj-ribbon__button" + (this.props.modifier ? ` rj-ribbon__button--${this.props.modifier}` : "");
        return (React.createElement("button", { className: cls, onClick: this.props.handler }, this.props.text));
    }
}
//# sourceMappingURL=RibbonButton.js.map